import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";

export const Route = createFileRoute("/_authenticated/logistics/containers")({
  component: ContainersLayout,
});

function ContainersLayout() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "shipments", actions: ["read"] }]}
    >
      <Outlet />
    </RouteGuardPermissions>
  );
}
